var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.preFillItems),function(fill){return _c('div',{key:fill.prefillId},[_c('PreFillItem',_vm._b({on:{"use":function($event){return _vm.onUse(fill.prefillId)}}},'PreFillItem',fill,false))],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }